import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

interface TableLoadingProps {
  height?: number | string;
}

export const TableLoading = ({ height = "auto" }: TableLoadingProps) => {
  return (
    <Grid container justifyContent="center" alignItems="center" height={height}>
      <Grid item>
        <CircularProgress color="secondary" size={75} />
      </Grid>
    </Grid>
  );
};
